import { createReducer, on } from '@ngrx/store';
import * as UsersRolesActions from '../actions/users-roles.actions';

export const usersRolesFeatureKey = 'usersRoles';

export interface State {
  record: any;
  error: any;
  loaded: boolean;
  loading: boolean;
}

export const initialState: State = {
  record: null,
  error: null,
  loaded: false,
  loading: false,
};


export const reducer = createReducer(
  initialState,

  on(UsersRolesActions.loadUsersRoles, () => ({
    record: null,
    error: null,
    loaded: false,
    loading: true,
  })),
  on(UsersRolesActions.loadUsersRolesSuccess, (state, action) => ({
    record: action.data.data,
    error: null,
    loaded: true,
    loading: false,
  })),
  on(UsersRolesActions.loadUsersRolesFailure, (state, action) => ({
    record: null,
    error: action.error,
    loaded: false,
    loading: false,
  })),
  on(UsersRolesActions.clearUsersRolesState, () => ({
    record: null,
    error: null,
    loaded: false,
    loading: false,
  })),
);
